import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";

import { sxTypographyAdvice, sxTypographyAdviceTitle } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { InvitationWarningCardProps } from "../../../interfaces/props/SaudeBemEstar/PalestrasEventos/InvitationWarningCardProps";

export const InvitationWarningCard: React.FC<InvitationWarningCardProps> = ({ message, title }) => {
  const { textStyleAccessibilityWithMargin, textStyleAccessibility, contrastStyle, contrastBorderAccessibility } = useAccessibility();
  return (
    <div className="advice-container" tabIndex={-1} style={{ ...contrastStyle, ...contrastBorderAccessibility }}>
      <div className="advice-icon-holder">
        <FontAwesomeIcon icon={faTriangleExclamation} className="far-triangle-exclamation" />
      </div>
      <div>
        <Typography style={textStyleAccessibilityWithMargin} sx={sxTypographyAdviceTitle}>
          {title}
        </Typography>
        <Typography style={textStyleAccessibility} sx={sxTypographyAdvice}>
          {message}
        </Typography>
      </div>
    </div>
  );
};
